'use client'

import { useGetProjectId } from '@/app/slugs'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { useQuery } from '@tanstack/react-query'
import { ProjectBriefAnswer } from '../../lib'
import services from '../services'

const useGetProjectBriefAnswers = () => {
  const { projectId } = useGetProjectId()
  const queryKey = [queryKeys((a, m) => a.project.getProjectBriefAnswers({ projectId }) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getProjectBriefAnswers({ projectId })),
    enabled: Boolean(projectId),
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
    data: query.data || [],
  } as typeof query & { data: ProjectBriefAnswer[]; queryKey: typeof queryKey }
}

export default useGetProjectBriefAnswers
